import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import { ShieldCheck, HardHat, Wrench, Download, CheckCircle } from '@phosphor-icons/react';
import { Loader2 } from 'lucide-react';

const AUTO_CARDS = [
  {
    type: 'pgc',
    label: 'PGC',
    desc: 'Plan General de Coordination sécurité et protection de la sante. Pre-rempli avec les donnees du chantier.',
    icon: ShieldCheck,
    color: '#FF6B00',
    borderClass: 'border-l-[#FF6B00]',
    iconBg: 'bg-[#FF6B00]/10',
    iconColor: 'text-[#FF6B00]',
    badgeClass: 'text-[#FF6B00] bg-[#FF6B00]/10',
    btnClass: 'bg-[#FF6B00] hover:bg-orange-700',
    features: ['Intervenants et entreprises', 'Analyse des risques', 'Mesures de prevention', 'Organisation des secours', 'Coordination des operations'],
  },
  {
    type: 'ppsps',
    label: 'PPSPS',
    desc: 'Plan Particulier de Sécurité et de Protection de la Sante. Conforme aux articles R.4532-56 a R.4532-74.',
    icon: HardHat,
    color: '#3B82F6',
    borderClass: 'border-l-blue-500',
    iconBg: 'bg-blue-500/10',
    iconColor: 'text-blue-500',
    badgeClass: 'text-blue-500 bg-blue-500/10',
    btnClass: 'bg-blue-600 hover:bg-blue-700',
    features: ['Renseignements generaux', 'Description des travaux', 'Analyse des risques', 'Mesures de prevention (EPI/EPC)', 'Organisation des secours'],
  },
  {
    type: 'diuo',
    label: 'DIUO',
    desc: "Dossier d'Intervention Ulterieure sur l'Ouvrage. Conforme aux articles R.4532-95 a R.4532-98.",
    icon: Wrench,
    color: '#10B981',
    borderClass: 'border-l-emerald-500',
    iconBg: 'bg-emerald-500/10',
    iconColor: 'text-emerald-500',
    badgeClass: 'text-emerald-500 bg-emerald-500/10',
    btnClass: 'bg-emerald-600 hover:bg-emerald-700',
    features: ["Identification de l'ouvrage", 'Plans et documents de reference', 'Acces et circulation', 'Reseaux et fluides', 'Consignes de sécurité'],
  },
];

export function AutoGenerateCards({ chantiers, selections, onSelectionChange, onGenerate, generatingStates }) {
  return (
    <div>
      <h2 className="text-base font-semibold text-[#111827] mb-3" data-testid="section-auto-csps">Génération automatique 1-clic</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {AUTO_CARDS.map(card => {
          const Icon = card.icon;
          const selectedChantier = selections[card.type] || '';
          const isGenerating = generatingStates[card.type] || false;
          return (
            <Card key={card.type} className={`border-l-4 ${card.borderClass} hover:shadow-lg transition-all`} data-testid={`auto-${card.type}`}>
              <CardHeader className="pb-3">
                <div className="flex items-start justify-between">
                  <div className={`w-12 h-12 rounded-xl ${card.iconBg} flex items-center justify-center`}>
                    <Icon size={24} className={card.iconColor} />
                  </div>
                  <span className={`text-[10px] font-bold ${card.badgeClass} px-2 py-1 rounded`}>AUTO</span>
                </div>
                <CardTitle className="text-base mt-2">{card.label}</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-sm text-[#4B5563]">{card.desc}</p>
                <ul className="text-xs text-[#6B7280] space-y-1">
                  {card.features.map(f => (
                    <li key={f} className="flex items-center gap-1.5">
                      <CheckCircle size={12} className="text-emerald-500 flex-shrink-0" /> {f}
                    </li>
                  ))}
                </ul>
                <Select value={selectedChantier} onValueChange={(v) => onSelectionChange(card.type, v)}>
                  <SelectTrigger className="h-11" data-testid={`auto-${card.type}-chantier-select`}>
                    <SelectValue placeholder="Sélectionner un chantier" />
                  </SelectTrigger>
                  <SelectContent position="popper" className="z-[100]">
                    {(chantiers || []).filter(c => c && c.id && c.name).map(c => (
                      <SelectItem key={c.id} value={String(c.id)} className="py-3">{c.name}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                <Button onClick={() => onGenerate(card.type, selectedChantier)}
                  disabled={!selectedChantier || isGenerating}
                  className={`w-full h-11 ${card.btnClass}`} data-testid={`auto-${card.type}-btn`}>
                  {isGenerating ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Download size={18} className="mr-2" />}
                  {isGenerating ? 'Génération...' : `Télécharger le ${card.label}`}
                </Button>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
